import React from 'react';
import { createRoot } from 'react-dom/client';
import {I18nextProvider, initReactI18next} from "react-i18next";
import i18next from "i18next";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import common_en from "./translations/en/common.json";
import common_es from "./translations/es/common.json";
import { branding } from "./config";
import { HelmetProvider } from "react-helmet-async";

const languages = ['en','es'];

const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
      }
  }
  return null;
}

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: getCookie('CS_CurrentUICulture') || navigator.language || 'en',
  debug: true,
  whitelist: languages,
  resources: {
    en: {
      common: common_en
    },
    es: {
      common: common_es
    }
  },
  interpolation: { escapeValue: false, defaultVariables: { brandName: branding.name, brandAccountName: branding.accountName } },  // React already does escaping
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </I18nextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
